"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { AdminSystemPostingTemplateUpsertRequest } from "@chotca/config";
import { getSdk } from "../sdk";
import { qk } from "../query-keys";

// Admin-side CRUD for "Mẫu hệ thống" — the templates that power the
// "Bắt đầu nhanh" picker on the employer post form.

export function useAdminSystemPostingTemplates() {
  return useQuery({
    queryKey: qk.admin.systemPostingTemplates,
    queryFn: () => getSdk().admin.listSystemPostingTemplates(),
    staleTime: 30_000,
  });
}

export function useCreateAdminSystemPostingTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: AdminSystemPostingTemplateUpsertRequest) =>
      getSdk().admin.createSystemPostingTemplate(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.admin.systemPostingTemplates });
    },
  });
}

export function useUpdateAdminSystemPostingTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (args: {
      templateId: string;
      body: AdminSystemPostingTemplateUpsertRequest;
    }) =>
      getSdk().admin.updateSystemPostingTemplate(args.templateId, args.body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.admin.systemPostingTemplates });
    },
  });
}

export function useDeleteAdminSystemPostingTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (templateId: string) =>
      getSdk().admin.deleteSystemPostingTemplate(templateId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.admin.systemPostingTemplates });
    },
  });
}
